import { useState, useEffect } from 'react';
import {
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Grid,
    Alert
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from 'react-redux';
import { createFertilizer, getFertilizers, updateFertilizerActiveState } from '../../../../../../actions/carbonfootprint';
import CFAddItem from '../../../CFAddItem';

export default function CultivationFertiliser({ groupId }) { // year
    const dispatch = useDispatch()
    const { loading, fertilizers } = useSelector(state => state.carbonfootprint)
    const [errorMessage, setErrorMessage] = useState(null)
    const [selectedListedFertiliser, setSelectedListedFertiliser] = useState('')
    const [items, setItems] = useState([]);

    useEffect(() => {
        dispatch(getFertilizers(groupId))
    }, [groupId, dispatch])

    const formFields = [
        {
            name: 'productName',
            label: 'Product Name',
            type: 'text',
            required: true
        },
        {
            name: 'isProducedOnSite',
            label: 'Produced on-site?',
            type: 'checkbox',
            // required: true // this field is unused in the backend
        },
        {
            name: 'supplier',
            label: 'Supplier',
            type: 'text',
            required: true
        },
        {
            name: 'linkToProduct',
            label: 'Link to product on website',
            type: 'text',
        },
        {
            name: 'category',
            label: 'Select Category',
            type: 'select',
            options: ['Synthetic', 'Organic'],
            required: true
        },
        {
            name: 'percentageN',
            label: 'Define % of active ingredient (N) (Optional)',
            type: 'number',
        },
        {
            name: 'percentageP',
            label: 'Define % of active ingredient (P) (Optional)',
            type: 'number',
        },
        {
            name: 'percentageK',
            label: 'Define % of active ingredient (K) (Optional)',
            type: 'number',
        },
        {
            name: "applicationRate",
            label: "How is the application rate defined",
            type: "select",
            options: ['kg/ha', 'L/ha'],
            required: true
        },
        {
            name: 'invoice',
            label: 'Upload invoice',
            type: 'file'
        },
    ];

    const initialState = formFields.reduce((obj, field) => {
        obj[field.name] = '';
        return obj;
    }, {});

    const handleFormSubmit = data => {
        dispatch(createFertilizer(data, groupId))
        setItems(prevItems => [...prevItems, data]);
    };


    const handleAddFertilizerToList = () => {
        if (selectedListedFertiliser !== '') {
            setErrorMessage(null)
            dispatch(updateFertilizerActiveState(groupId, selectedListedFertiliser)).then(() => {
                dispatch(getFertilizers(groupId))
            })
        } else setErrorMessage('Please select a listed fertilizer.')
    }

    const handleListedFertiliserChange = (event) => {
        setErrorMessage(null)
        setSelectedListedFertiliser(event.target.value)
    }

    const columns = [
        {
            field: 'product_name',
            headerName: 'Product Name',
            flex: 1,

        },
        {
            field: 'supplier',
            headerName: 'Supplier',
            flex: 1,
        },
        {
            field: 'link_to_product_on_site',
            headerName: 'Link to product',
            flex: 1,
        },
        {
            field: 'category',
            headerName: 'Category',
            flex: 1,
        },
        {
            field: 'percentage_active_ingredient_nitrogen',
            headerName: 'Percentage N',
            flex: 1,
        },
        {
            field: 'percentage_active_ingredient_phosphorus',
            headerName: 'Percentage P',
            flex: 1,
        },
        {
            field: 'percentage_active_ingredient_potassium',
            headerName: 'Percentage K',
            flex: 1,
        },
        {
            field: 'application_rate_unit',
            headerName: 'Application rate',
            flex: 1,
        }
    ]

    return (
        <Grid col="12" sx={{ width: '100%' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
                <CFAddItem
                    formFields={formFields}
                    initialState={initialState}
                    onFormSubmit={handleFormSubmit}
                    items={items}
                    addTitle='Add New Fertiliser'
                />
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Listed Fertilisers</InputLabel>
                    <Select
                        name='listedFertiliser'
                        value={selectedListedFertiliser}
                        onChange={handleListedFertiliserChange}
                        label={'Listed Fertilisers'}
                    >
                        {loading
                            ? <>loading</>
                            : fertilizers.map((fertilizer) => {
                                return (
                                    <MenuItem key={fertilizer._id} value={fertilizer._id}>
                                        {fertilizer.product_name}
                                    </MenuItem>
                                );
                            })}
                    </Select>
                </FormControl>
                {errorMessage && <Alert severity='error' sx={{ mb: 2, width: 'fit-content' }}>{errorMessage}</Alert>}
                <Button sx={{ mt: 2, mb: 2 }} variant='contained'
                    //color={fertilizers?.filter((f) => f.is_active).map((f) => f._id).includes(selectedListedFertiliser) ? 'warning' : 'primary'} 
                    color="primary"
                    onClick={handleAddFertilizerToList}>
                    {/* {fertilizers?.filter((f) => f.is_active).map((f) => f._id).includes(selectedListedFertiliser) ? 'Remove Fertilizer from list' : 'Add Fertiliser to list'} */}
                    Add Fertilizer to list
                </Button>
                {loading ? <h1>loading</h1> :
                    <Grid col='12' sx={{ height: '100%' }}>
                        <TableContainer component={Paper} sx={{ height: 'auto' }}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell key={column.field} align="center">
                                                {column.headerName}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {fertilizers && fertilizers?.length > 0 &&
                                        fertilizers?.filter((fertilizer) => fertilizer.is_active).map((row) => (
                                            <TableRow
                                                key={row._id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                {columns.map((column) => (
                                                    <TableCell key={column.field} align="center">
                                                        {row[column.field]}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                }
            </Box>
        </Grid>
    );
}
